import { NotFoundError } from '@cian/peperrors';

import { showAlert } from '../slices/alertSlice';
import { createAppAsyncThunk } from '../store/createAppAsyncThunk';
import { EAlert } from '../types/alert';
import { EExceptionDomain } from '../types/exceptionDomains';
import { copyToClipboard } from '../utils/copyToClipboard';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';

export interface ICopyMessageParameters {
  messageId: string;
}

export const copyMessage = createAppAsyncThunk(
  'messages/copyMessage',
  async (
    { messageId }: ICopyMessageParameters,
    {
      dispatch,
      extra: {
        logger,
        custom: { messagesMap },
      },
    },
  ) => {
    const messageItem = messagesMap.get(messageId);

    if (!messageItem) {
      const exception = new NotFoundError({
        domain: EExceptionDomain.Messages,
        message: 'Не удалось найти сообщение для копирования',
        details: {
          messageId,
        },
      });

      logger.error(exception);

      return;
    }

    const { htmlText, message } = messageItem.message.message;

    const textToCopy = htmlText || message;

    try {
      await copyToClipboard(textToCopy);
      dispatch(showAlert({ type: EAlert.Info, message: 'Сообщение скопировано' }));
    } catch (error) {
      const errorToLog = getGenericLikeError({
        domain: EExceptionDomain.Messages,
        error,
        message: 'Ошибка при копировании сообщения',
      });

      logger.error(errorToLog, { messageId });
    }
  },
);
